export default __webpack_public_path__ + "static/media/Emilio.dcf85c3e.jpeg";